<template>
  <div class="index">
    <div class="nav">
      <router-link :to="{ name: item.name }" :key="item.name"
      active-class="is-active"
      class="nav-item is-tab" v-for="item in userMenu">{{item.title}}</router-link>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import router from '../../router'

  export default {
    name: 'AboutNavbar',
    data () {
      return {
        userMenu: []
      }
    },
    computed: {
      ...mapState(['user', 'menu'])
    },
    created () {
      if (this.$route.name === 'About') {
        router.push('/about/offices')
      }
      this.userMenu = this.menu.about.filter(i => i.roles.includes(this.user.role))
    }
  }
</script>

<style scoped>
.nav {
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// Index.vue?3ef1e9f1